import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CallbackPage_content" }
const _hoisted_2 = { class: "CallbackPage_loginPanel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { id: "CallbackPage" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "lds-heart" }, [
          _createElementVNode("div")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "CallbackPage_maintenance" }, [
          _createTextVNode("Park.it is under maintenance"),
          _createElementVNode("br"),
          _createTextVNode("we'll come back soon...")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _createElementVNode("span", {
              class: "CallbackPage_link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleHomeClick && _ctx.handleHomeClick(...args)))
            }, " Home Screen ")
          ])
        ])
      ])
    ]),
    _: 1
  }))
}